<div class="policy bg-light">

    <div class="policy__container" [style.height.px]="appAlert.windowHeight - 200">
        <div class="policy_header">
            <h1>Privacy Policy</h1>
        </div>

        <div class="policy_paragraph">
            <p class="policy_paragraph__content">
                The present Privacy Policy was adopted in connection with the entry into force of the Regulation
                (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016 on the protection of
                individuals with regard to the processing of personal data and on the free movement of such data,
                and repealing the Directive 95/46/EC (Official Journal of the European Union no. L 119/1 of
                4/5/2016; hereinafter: GDPR). The purpose of the Policy is, in particular, to fulfil the information
                obligation referred to in Articles 13 and 14 GDPR.
            </p>
            <h1 id="definitions">1. Definitions</h1>
            <p class="policy_paragraph__content">
                The following terms are used in the present Policy:
            </p>
            <ol class="pp_list">
                <li class="policy__list-item">We,<strong>TECH STEROWNIKI</strong>, administrator - <strong>TECH STEROWNIKI
                    Spółka z ograniczoną odpowiedzialnością
                    Sp.k..</strong> with its registered office in Wieprz 34-122 at ul. Biała Droga 31 entered
                    into the Register of Entrepreneurs of the National Court Register under the KRS number
                    0000594881, NIP [Tax ID]: 5512360632, REGON: 356782780.
                </li>
                <li class="policy__list-item">You, Mr., Mrs., You - persons whose personal data is processed by TECH STEROWNIKI</li>
            </ol>
        </div>

        <div class="policy_paragraph">
            <h1>2. Who is the data administrator?</h1>
            <p class="policy_paragraph__content">
                The data administrator is a person who determines the purposes and methods of personal data
                processing. The administrator of your personal data is
                <strong>TECH STEROWNIKI Spółka z ograniczoną odpowiedzialnością Sp.k.</strong>
            </p>
        </div>

        <div class="policy_paragraph">
            <h1>3. What personal data do we process?</h1>
            <p class="policy_paragraph__content">
                In connection with our business, we process, in particular, the personal data of: our contractors who
                are natural persons (including: customers, suppliers, etc.), contact persons indicated by these
                contractors (including: sales representatives, persons indicated as responsible for the
                implementation of joint projects, drivers, etc.), people with whom we correspond, people who are
                authorized to enter our premises, people interested in employment, employees, as well as people
                who have relationships with our employees that bear legal consequences (including children, family
                members, etc.). The scope of processed data is in each case adequate to the purposes of their
                processing.
            </p>
        </div>

        <div class="policy_paragraph">
            <h1>4. For what purposes do we process the data?</h1>
            <p class="policy_paragraph__content">
                Your personal data can be processed for the following purposes:
            </p>
            <ol type="1">
                <li class="policy__list-item">
                    Performance of concluded contracts or taking action to conclude a contract at your request (based
                    on art. 6: section 1, letter b of the GDPR). In this case, the data is processed for the term of the
                    contract, as well as any further period necessary for the full implementation of the rights and
                    obligations arising from it.
                </li>
                <li class="policy__list-item">
                    Compliance with our legal obligations, in particular, in the field of tax law, accounting or
                    archiving provisions, provisions on counteracting money laundering, provisions regulating the
                    social security system, etc. (art. 6: section 1, letter c of the GDPR). In these cases, time of data
                    processing is determined by the provisions constituting the basis of the respective obligation.
                </li>
                <li class="policy__list-item">
                    <p>
                        Implementation of our legitimate interest (art. 6: section 1, letter f of the GDPR) - consisting in:
                    </p>
                    <ol type="a">
                        <li class="policy__list-item">
                            conducting direct marketing of our goods or services,
                        </li>
                        <li class="policy__list-item">
                            creating compilations, analyzes and statistics - which includes, in particular, market
                            research, commercial data analysis, service development planning, etc.,
                        </li>
                        <li class="policy__list-item">
                            determining, investigating or defending against claims,
                        </li>
                        <li class="policy__list-item">
                            correspondence using all known technologies, including: traditional mail, electronic mail
                            (e-mail) or other communication channels (e.g. instant messaging, etc.),
                        </li>
                        <li class="policy__list-item">
                            telephone contacts,
                        </li>
                        <li class="policy__list-item">
                            initiating and maintaining business contacts,
                        </li>
                        <li class="policy__list-item">
                            correct displaying of our websites,
                        </li>
                        <li class="policy__list-item">
                            conducting visual monitoring of our plant (plants) - to the extent required to ensure the
                            safety of people and property located on its (their) premises and keeping secret information, the
                            disclosure of which could expose us to damage.
                        </li>
                    </ol>
                    <p>
                        In the cases listed in item 3 - the data will be processed for the duration of the interest in connection
                        with which they are processed. In particular: (i) marketing activities will be conducted until you
                        submit an appropriate objection, and (ii) the video monitoring record will be stored for no longer
                        than 3 months, unless otherwise provided for in generally applicable regulations.
                    </p>
                </li>
                <li class="policy__list-item">
                    Sometimes your personal data may be processed for other purposes, based on an appropriate
                    consent - expressed in a specific, voluntary, informed and unambiguous manner (art. 6: section 1,
                    letter a of the GDPR). The consent is, in particular, the basis for the processing of certain data
                    collected for the purposes of recruitment procedures (as contained in the CV, etc.).
                </li>
            </ol>
            <p>
                In this case: (i) the data will be processed for a period adequate to the purpose indicated in the
                consent, (ii) you reserve the right to withdraw your consent at any time, without affecting the
                lawfulness of processing based on your consent before its withdrawal.
            </p>
        </div>

        <div class="policy_paragraph">
            <h1>5. Is it mandatory to provide personal data?</h1>
            <p class="policy_paragraph__content">
                You are under no obligation to provide us with your personal data. Nevertheless, the refusal may
                result in our inability to conclude or perform the contract concluded with us or to perform other
                activities (e.g. sending correspondence, granting access to the premises, secure participation in the
                recruitment process, etc.).
            </p>
        </div>

        <div class="policy_paragraph">
            <h1>Can the data be processed in processes involving automated decision-making,
                including "qualified" profiling?</h1>
            <p class="policy_paragraph__content">
                Currently, we do not apply any operations that would result in automated decision-making that
                would have legal effects on the part of the addressees or similarly significantly affect them. If such
                operations related to the processing of personal data are implemented in the future - we will ensure
                their compliance with the relevant provisions, including art. 22 of the GDPR.
            </p>
        </div>

        <div class="policy_paragraph">
            <h1>7. Who can we share your personal data with?</h1>
            <p class="policy_paragraph__content">
                Your personal data may be disclosed to third parties only if we are obliged or entitled to do so under
                the law. Such recipients of the data may be in particular:
            </p>
            <ol type="1">
                <li class="policy__list-item">
                    Processors, including:
                    <ol type="a">
                        <li class="policy__list-item">
                            persons servicing our IT infrastructure or systems, as well as utilizing unnecessary
                            documentation or data carriers,
                        </li>
                        <li class="policy__list-item">
                            subcontractors participating in the performance of our obligations towards you,
                        </li>
                        <li class="policy__list-item">
                            persons providing services related to the performance or improvement of the sales process
                            (e.g. payment agents, couriers or carriers, advertising agencies, experts participating in complaint
                            procedures),
                        </li>
                        <li class="policy__list-item">
                            persons providing audit or advisory services to us - e.g. in the field of legal, tax or
                            accounting assistance.
                        </li>
                    </ol>
                </li>
                <li class="policy__list-item">
                    Other administrators, including:
                    <ol type="a">
                        <li class="policy__list-item">
                            public authorities authorized to request the disclosure of the data,
                        </li>
                        <li class="policy__list-item">
                            companies related to us,
                        </li>
                        <li class="policy__list-item">
                            other entities - in cases where the nature of the services provided by them to us means that
                            the indicated entities independently determine the purposes and methods of personal data
                            processing and therefore become personal data administrators. This may apply, in particular, to:
                            advertising agencies, agencies participating in the organization of competitions or promotional
                            events, banks, couriers and carriers, as well as entities cooperating with us in handling accounting,
                            tax or legal matters,
                        </li>
                        <li class="policy__list-item">
                            buyers of claims against you - in the event that we decide to transfer such claims, in
                            particular, due to the existence of significant payment arrears.
                        </li>
                    </ol>
                </li>
            </ol>
            <p>
                We will not disclose your personal data to persons who are not authorized to process it.
            </p>
        </div>

        <div class="policy_paragraph">
            <h1>8. Can your personal data be transferred outside the European Economic Area (EEA)?</h1>
            <p class="policy_paragraph__content">
                Currently, we have no plans of transferring your data outside the European Economic Area.
                However, we do not rule out that we may consider it justified in the future. In this case, your data
                will be secured in the manner required by generally applicable regulations, in particular, through the
                use of the so-called Standard Contractual Clauses (SCCs).
            </p>
        </div>

        <div class="policy_paragraph">
            <h1>9. What rights do you have in relation to the processing of personal data?</h1>
            <p class="policy_paragraph__content">
                You can request us, in particular, to:
            </p>
            <ol type="1">
                <li class="policy__list-item">
                    access the data processed by us (including: information about data processing by us or provision
                    of a copy of the data),
                </li>
                <li class="policy__list-item">
                    rectify (correct) data,
                </li>
                <li class="policy__list-item">
                    limit processing (suspension of data operations or non-deletion of data),
                </li>
                <li class="policy__list-item">
                    delete data ("the right to be forgotten"),
                </li>
                <li class="policy__list-item">
                    transfer data to another administrator.
                </li>
            </ol>
            <p>
                The above requests may be sent, in particular, in the manner specified in item 13
                below - and will be dealt with in accordance with applicable laws, including Articles 15-20 of the
                GDPR.
            </p>
        </div>

        <div class="policy_paragraph">
            <h1>10. Right to object</h1>
            <p class="policy_paragraph__content">
                Notwithstanding the foregoing, you are entitled to object to the processing of data, which is based
                on our legitimate interest. In that case:
            </p>
            <ol type="1">
                <li class="policy__list-item">
                    If personal data are processed for marketing purposes - we will stop such processing
                    immediately.
                </li>
                <li class="policy__list-item">
                    If the basis for data processing is an interest of a different type - we will cease such processing,
                    unless we demonstrate: a) that the said interest overrides your interests, rights and freedoms, or b)
                    the existence of a basis for establishing, investigating or defending claims is ascertained.
                </li>
            </ol>
            <p>
                The right to object may be exercised, in particular, by sending an appropriate statement in the
                manner specified in item 13 below.
            </p>
        </div>

        <div class="policy_paragraph">
            <h1>11. Complaint to the supervisory authority</h1>
            <p class="policy_paragraph__content">
                If you believe that the processing of your data violates applicable law, you have the right to lodge a
                complaint with the supervisory authority, i.e. President of the Polish Personal Data Protection
                Office.
            </p>
        </div>

        <div class="policy_paragraph">
            <h1>12. Place of publication and updates of the privacy policy</h1>
            <p class="policy_paragraph__content">
                This privacy policy may be subject to changes and amendments from time to time. The current
                version of the policy will be available at all times on our website at:
                <a href="/docs/policies/privacy_policy_tech.pdf"
                   download="privacy_policy_tech.pdf" target="_self">
                   {{ appAlert.origin() + '/docs/policies/privacy_policy_tech.pdf' }}
                </a>
            </p>
        </div>

        <div class="policy_paragraph">
            <h1 id="">13. How can you contact us?</h1>
            <p class="policy_paragraph__content">
                Should you have any questions about how we use your personal data, you can contact us by
                telephone, email or letter at the following numbers and addresses:
            </p>
            <strong>TECH STEROWNIKI Spółka z ograniczoną odpowiedzialnością Sp.k.</strong><br />
            <p>
                Wieprz 34-122 at ul. Biała Droga 31 - with the annotation: "personal data protection"
                tel. +48 33 875 93 80; e-mail: serwis&#64;techsterowniki.pl.
            </p>
        </div>

    </div>

    <div class="policy__buttons-box">
        <input type="button"
               [value]="subtitles.setSubtitle(1744)"
               class="app-alert__button  bg-ok color-light font-bold font-14 cursor-pointer"
               (click)="appAlert.closePolicy()">
    </div>

</div>

